import React from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import xplanLabels from "../../util/XplanLabels";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { formatDateTime } from "../../util/FormUtils";

const doNotTrack = [
    "undefined",
    "id",
    "versionId",
    "createdAt",
    "updatedBy",
    "updatedAt",
];

const HistoryLogTotal = ({ xplans }) => {
    const history = [];

    // Iterate over each version of an xplan, comparing it to the previous version
    for (let i = 0; i <= xplans.length - 1; i++) {
        const currVer = xplans[i];
        const prevVer = xplans[i + 1];

        const changes = [];
        // Iterate over each key in the current xplan and compare it to the previous
        for (const k in currVer) {
            if (!doNotTrack.includes(k) && currVer.hasOwnProperty(k)) {
                const currVal = currVer[k];
                const prevVal = i === xplans.length - 1 ? null : prevVer[k];

                // If value is different, store the change
                if (i === xplans.length || currVal !== prevVal) {
                    const label = xplanLabels[k];

                    if (label && (prevVal || currVal)) {
                        changes.push(
                            <div className="historyContentEntry">
                                <span className="historyFieldName">
                                    {`${label}`} <ArrowRightIcon style={{ fontSize: "22px" }} />
                                </span>{" "}
                                {`${currVal}`}
                            </div>
                        );
                    }
                }
            }
        }

        history.push(
            <div className="historyEntry">
                <div className="historyUserTime">
                    <h2 className="historyUser">{currVer.updatedBy}</h2>{" "}
                    {/*<Typography>{changes.push(currVer.updatedBy)}</Typography>*/}
                    <p className="historyTime">{formatDateTime(currVer.updatedAt)}</p>
                </div>
                {changes.map((change, index) => (
                    <div key={index}>{change}</div>
                ))}
            </div>
        );
    }

    // Return an accordion item for all changes
    return (
        <div className="historyLog">
            <Accordion className="historyLogAccordion">
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel-content`}
                    id={`panel-header`}
                >
                    <h1 className="historyLogTitle">Change Log</h1>
                </AccordionSummary>
                <AccordionDetails className="historyContent">
                    {history}
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default HistoryLogTotal;
